import { useEffect, useState } from "react";
import { useParams } from "react-router";
import Notify from "config/notify";
import {
  ItemClientPrice,
  ItemPriceSelectResponse,
  ItemPriceUpdateRequest,
  ItemStorePurchasePrice,
} from "../types/item";
import { fetchItemPrice, updateItemPrice } from "../api/itemApi";

/**
 *
 */
const useItemPrice = () => {
  const { id } = useParams();
  const [itemStorePurchasePrice, setItemStorePurchasePrice] = useState<ItemStorePurchasePrice[]>(
    [],
  );
  const [originalItemStorePurchasePrice, setOriginalItemStorePurchasePrice] = useState<
    ItemStorePurchasePrice[]
  >([]);

  const [itemClientPrice, setItemClientPrice] = useState<ItemClientPrice[]>([]);
  const [originalItemClientPrice, setOriginalItemClientPrice] = useState<ItemClientPrice[]>([]);

  const [searchId, setSearchId] = useState(id);
  const [item, setItem] = useState<ItemPriceSelectResponse["list"][0] | null>();

  const fetchData = async () => {
    if (searchId) {
      setItem(null);
      const data = await fetchItemPrice({
        item_cd: searchId,
        limit: 1,
        offset: 0,
      });
      if (data.list.length > 0) {
        const itemData = data.list[0];
        setItem(itemData);
        if (Array.isArray(itemData.mst_yh_item_store_purchase_price)) {
          setItemStorePurchasePrice(itemData.mst_yh_item_store_purchase_price);
          setOriginalItemStorePurchasePrice(itemData.mst_yh_item_store_purchase_price);
        } else {
          setItemStorePurchasePrice([]);
          setOriginalItemStorePurchasePrice([]);
        }
        if (Array.isArray(itemData.mst_item_client_price)) {
          setItemClientPrice(itemData.mst_item_client_price);
          setOriginalItemClientPrice(itemData.mst_item_client_price);
        } else {
          setItemClientPrice([]);
          setOriginalItemClientPrice([]);
        }
      }
    }
  };

  const handleChangeStorePurchasePrice = (
    index: number,
    key: keyof ItemStorePurchasePrice,
    value: string,
  ) => {
    const newStorePurchasePrice = [...itemStorePurchasePrice];
    newStorePurchasePrice[index] = {
      ...newStorePurchasePrice[index],
      [key]: value,
    };
    setItemStorePurchasePrice(newStorePurchasePrice);
  };

  const handleChangeClientPrice = (index: number, key: keyof ItemClientPrice, value: string) => {
    const newClientPrice = [...itemClientPrice];
    newClientPrice[index] = {
      ...newClientPrice[index],
      [key]: value,
    };
    setItemClientPrice(newClientPrice);
  };

  const handleUpdateStorePurchasePrice = async (
    index: number,
    key: keyof ItemStorePurchasePrice,
  ) => {
    if (item) {
      const shouldUpdate =
        itemStorePurchasePrice[index][key] !== originalItemStorePurchasePrice[index][key];
      if (shouldUpdate) {
        try {
          const data: ItemPriceUpdateRequest = {
            item_cd: item.item_cd,
            mst_yh_item_store_purchase_price: {
              store_cd: itemStorePurchasePrice[index].store_cd,
              vendor_cd: itemStorePurchasePrice[index].vendor_cd,
              [key]: Number(itemStorePurchasePrice[index][key]),
            },
          };
          await updateItemPrice(data);
          setOriginalItemStorePurchasePrice(() => itemStorePurchasePrice);
        } catch (error) {
          console.error("Error updating store purchase price:", error);
        }
      }
    }
  };

  const handleUpdateClientPrice = async (index: number, key: keyof ItemClientPrice) => {
    if (item) {
      const shouldUpdate = itemClientPrice[index][key] !== originalItemClientPrice[index][key];
      if (shouldUpdate) {
        try {
          const data: ItemPriceUpdateRequest = {
            item_cd: item.item_cd,
            mst_item_client_price: {
              client_cd: itemClientPrice[index].client_cd,
              [key]: Number(itemClientPrice[index][key]),
            },
          };
          await updateItemPrice(data);

          setOriginalItemClientPrice(() => itemClientPrice);
        } catch (error) {
          console.error("Error updating client price:", error);
        }
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    item,
    itemStorePurchasePrice,
    itemClientPrice,
    searchId,
    setSearchId,
    fetchData,
    handleChangeStorePurchasePrice,
    handleChangeClientPrice,
    handleUpdateStorePurchasePrice,
    handleUpdateClientPrice,
  };
};

export default useItemPrice;
